import React from 'react';
import {Container, Text,Box,Link} from "@chakra-ui/react";
import SvgNotFound from "../../assets/svg/SvgNotFound";

const NotFound = () => {
    return (
        <Box w="full">
            <Container maxW="container.xl" display="flex" flexDir="column" justifyContent="center" alignItems="center"  h="100vh">
                <Box>
                    <SvgNotFound width={{base:"225px",md:"398px"}}/>
                    <Text textAlign="start" py="16px" fontFamily='Raleway' fontWeight="400" fontSize="14px" color="#000000"> Страница не найдена. <br/> Вернуться на <Link color="blue" href="/">главную страницу</Link>.</Text>
                </Box>
            </Container>
        </Box>
    );
};

export default NotFound;